import { createContext, useContext } from 'react';
import { IParameterInfo, IParameterOption } from '~/src/dash/components/forms/formBuilder/common';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';

// we allow 'any' for object & defaultObject to allow flexibility on
// the form details that are passed into the FormBuilder
interface IFormBuilderContext {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  defaultObject: Record<string, any>;
  object: Record<string, any>;
  /* eslint-disable @typescript-eslint/no-explicit-any */

  activeParamKeys: Set<string>;
  cfg: Record<string, IParameterInfo>;
  handleRemoveParameter: (idx: number) => void;
  handleSelectParameter: (idx: number, key: string) => void;
  lists: Record<string, ISelectOption[]>;
  options: IParameterOption[];
}

export const FormBuilderContext = createContext({} as IFormBuilderContext);

export const useFormBuilderStore = (): IFormBuilderContext => useContext(FormBuilderContext);
